import { render, staticRenderFns } from "./DecisionPage.vue?vue&type=template&id=7d3bb24a&"
import script from "./DecisionPage.vue?vue&type=script&lang=js&"
export * from "./DecisionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports